export default {
  'layouts.userLayout.title': 'DocFluxa - Enterprise AI Intelligent Document Management System',

  // Login page
  'login.accountLogin.tab': 'Account Login',
  'login.failure': 'Login failed, please try again!',
  'login.success': 'Login successful!',
  'login.password.expired': 'Password expired, please reset your password!',
  'login.password.update.success': 'Password updated successfully!',
  'login.password.update.fail': 'Password update failed',
  'login.request.fail': 'Request failed, please try again later',
  'login.password.security': 'Password must contain letters, numbers, and special characters, and be at least 8 characters long!',
  'login.contactAdmin': 'Forgot password? Please contact the administrator!',
  'login.alterPassword': 'Change Password',
  'login.password.strength.strong': 'Strength: Strong',
  'login.password.strength.medium': 'Strength: Medium',
  'login.password.strength.short': 'Strength: Too Short',
  'login.password.twice.match': 'The two passwords that you entered do not match!',
  'login.password.length': 'Password must be at least 8 characters long!',
  'login.password.case': 'Password must contain letters, numbers, and special characters!',
  'login.password.diff': 'The new password cannot be the same as the current password!',
  'login.password.tips': 'Please enter at least 8 characters and include letters, numbers, and special characters.',
  'login.currentPassword.required': 'Please input your current password!',
  'login.currentPassword.placeholder': 'Current Password',
  'login.newPassword.placeholder': 'At least 8 characters, containing letters, numbers, and special characters',
  'login.confirmPassword.required': 'Please confirm your password!',
  'login.confirmPassword.placeholder': 'Confirm Password',
  'login.backToLogin': 'Log in with an existing account',
  'login.updatePassword': 'Update Password',
  'login.username.placeholder': 'Username',
  'login.username.required': 'Please input your username!',
  'login.password.placeholder': 'Password',
  'login.password.required': 'Please input your password!',
  'login.forgotPassword': 'Forgot Password ?',
  'login.forgotPassword.modal.title': 'Reset Password',
  'login.forgotPassword.modal.content': 'A password reset email will be sent to the mailbox associated with account [{account}]. Please check your inbox to complete the reset.',
  'login.forgotPassword.modal.confirm': 'Send Email',
  'login.forgotPassword.modal.cancel': 'Cancel',
  'login.forgotPassword.success': 'Reset password email sent. Please check your inbox!',
  'login.forgotPassword.fail': 'Failed to send. Please try again later.',

  // Login page layout
  'login.submit': 'Login',
  'login.formSubTitle': 'Enter your account and password to continue',
  'login.leftTitle': 'Enterprise Intelligent Document Management Platform',
  'login.leftSubTitle': 'Let knowledge flow efficiently, empowering smart team collaboration',
  'login.feature.docParsing': 'Intelligent Document Parsing & Management',
  'login.feature.ragKnowledge': 'RAG Knowledge Base Building & Retrieval',
  'login.feature.aiQA': 'AI-Powered Content Q&A',
  'login.feature.permissionMgmt': 'Enterprise Permission Management',
  'login.feature.multiAppIntegration': 'Multi-App Integration Support',

  // Change password page
  'login.alertPwd.subTitle': 'Enter your current password and new password',

  // Reset password page
  'resetPassword.title': 'Reset Password',
  'resetPassword.subTitle': 'Please set your new login password',
  'resetPassword.leftTitle': 'Reset Your Password',
  'resetPassword.leftSubTitle': 'Please set a secure new password with at least 8 characters, including letters, numbers, and special characters.',
  'resetPassword.account': 'Account',
  'resetPassword.submit': 'Reset Password',
  'resetPassword.success': 'Password reset successfully. Please log in with your new password!',
  'resetPassword.fail': 'Reset failed, please try again.',
  'resetPassword.invalidLink': 'The link is invalid or has expired. Please request a new password reset.',
  'resetPassword.fetchError': 'Failed to retrieve account information, please try again.',
};
